import React, { useState } from 'react'
import Wysiwyg from './wysiwyg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const AccordionBand = ({ content }) => {
    const [openPanels, setOpenPanels] = useState([])

    const renderTitle = () => {
        if (content.title) {
            return (
                <h2>{content.title}</h2>
            )
        }
        return null
    }

    const renderPanelContent = (panelContents) => {
        let allContent = []
        panelContents.forEach((panel, index) => {
            switch (panel.bundle) {
            case 'wysiwyg':
                allContent.push(<Wysiwyg key={index} content={panel.data} />)
                break
            default:
                break
            }
        })
        return allContent
    }

    const handleToggle = (index) => {
        if (openPanels.includes(index)) {
            setOpenPanels(openPanels.filter(item => item !== index))
        } else {
            setOpenPanels([...openPanels, index])
        }
    }

    const renderPanels = () => {
        let allPanels = []
        content.items.forEach((item, index) => {
            const isOpen = openPanels.includes(index)
            allPanels.push(
                <div key={index} className={`panel ${isOpen ? 'open' : ''}`}>
                    <div className="panel-header" onClick={() => handleToggle(index)}>
                        <h3>{item.title}</h3>
                        <span className="icon-toggle">
                            <FontAwesomeIcon icon={`${isOpen ? 'minus' : 'plus'}`} />
                        </span>
                    </div>
                    <div className="panel-content">
                        {renderPanelContent(item.content)}
                    </div>
                </div>
            )
        })
        return allPanels
    }

    return (
        <div className="container">
            <div className="content-band accordions">
                {renderTitle()}
                {renderPanels()}
            </div>
        </div>
    )
}

export default AccordionBand
